import React from 'react';

const ChatMessageDataHora = ({ dataHora }) => {
    if (!dataHora) return null;

    return (
        <div className="chat-message-time">
            {dataHora}
        </div>
    );
};

export default ChatMessageDataHora;
